import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../../_metronic/_partials/controls'
import Table, { buttonsStyle, booleanFormatter } from '../../../../components/tables/table'
import ConfirmDialog from '../../../../components/dialogs/ConfirmDialog'
import { getCategories, updateCategory, syncCategories } from '../../../../../api/category'
import { Button, Tooltip } from '@material-ui/core'
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import VisibilityIcon from '@material-ui/icons/Visibility'
import { alertError, alertSuccess, alertLoading } from '../../../../../utils/logger'
import { useHistory } from 'react-router-dom'

function getData(categories) {
  let data = []
  for (let i = 0; i < categories.length; ++i) {
    if (!categories[i].isPostCategory) {
      const elem = {}
      elem.name = categories[i].name
      elem.quantity = categories[i].count
      elem.parent = categories.find(item => item.wordpress_id === categories[i].parent)?.name || '---'
      elem.active = categories[i].active
      elem.id = categories[i]._id
      data = data.concat(elem)
    }
  }
  return data
}

export default function CategoriesPage() {
  const [data, setData] = useState([])
  const [category, setCategory] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  function buttonFormatter(cell) {
    const elem = data.find(item => item.id === cell)
    return (<>
      <Tooltip title="View">
        <Button
          style={buttonsStyle} size="small"
          onClick={() => history.push('/product-view-category/' + cell)}>
          <VisibilityIcon/>
        </Button>
      </Tooltip>
      <Tooltip title={elem?.active ? "Disable" : "Enable"}>
        <Button
          style={buttonsStyle} size="small"
          onClick={() => {
            setCategory(elem)
            setOpenConfirmDialog(true)
          }}>
          {elem?.active ? <ToggleOffIcon/> : <ToggleOnIcon/>}
        </Button>
      </Tooltip>
    </>)
  }

  const columns = [
    { dataField: 'name', text: 'Name', sort: true },
    { dataField: 'quantity', text: 'Quantity', sort: true },
    { dataField: 'parent', text: 'Parent category', sort: true },
    { dataField: 'active', text: 'Active', align: 'center', headerAlign: 'center', formatter: booleanFormatter, sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter }
  ]

  useEffect(() => {
    getCategories().then((res) => {
      if (res.status === 200) {
        setData(getData(res.data))
        setRefresh(false)
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get categories.' })
    })
  }, [refresh])

  return (
    <>
      <Card>
        <CardHeader title='Categories list'>
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                alertLoading({ title: 'Getting all categories...'})
                syncCategories().then(res => {
                  if (res.status === 200) {
                    alertSuccess({ title: 'Done!', customMessage: 'All categories have been imported successfully.' })
                    setRefresh(true)
                  }
                }).catch(error => {
                  alertError({ error: error, customMessage: 'Could not sync categories.' })
                })
              }}
            >
              Sync categories
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table
            data={data}
            columns={columns}
          />
          <ConfirmDialog
            title={`Are you sure you want to ${category?.active ? 'disable' : 'enable'} this category?`}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              updateCategory(category.id, !category.active).then(res => {
                if (res.status === 204 || res.status === 200) {
                  alertSuccess({ title: `${category.active ? 'Disabled!' : 'Enabled!'}`, customMessage: `Category ${category.active ? 'disabled' : 'enabled'} successfully` })
                  setRefresh(true)
                }
              }).catch(error => {
                alertError({ error: error, customMessage: `Could not ${category.active ? 'disable' : 'enable'} category.` })
              })
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
